import type { WeightingFunctionFactoriesPoolKeyMap } from "../weighting-function";

/**
 * ResampleFilter preset interface.
 */
export interface ResampleFilterPreset {
  /**
   * Filter function factory name (in WeightingFunctionFactoriesPool).
   */
  filterFunctionFactory: keyof WeightingFunctionFactoriesPoolKeyMap | string;

  /**
   * Filter function factory arguments.
   */
  filterFunctionFactoryArgs: number[];

  /**
   * Window function factory name (in WeightingFunctionFactoriesPool).
   */
  windowFunctionFactory: keyof WeightingFunctionFactoriesPoolKeyMap | string;

  /**
   * Window function factory arguments.
   */
  windowFunctionFactoryArgs: number[];

  /**
   * Filter support.
   */
  support: number;

  /**
   * Filter scale.
   */
  scale: number;

  /**
   * Filter blur.
   */
  blur?: number;

  /**
   * Filter window support.
   */
  windowSupport?: number;
}

/**
 * Checks if passed object implements ResampleFilterPreset interface.
 *
 * @param candidate
 */
export function isResampleFilterPreset(
  candidate: unknown
): candidate is ResampleFilterPreset {
  type C = Partial<ResampleFilterPreset>;
  return (
    typeof candidate === "object" &&
    candidate !== null &&
    typeof (candidate as C).filterFunctionFactory === "string" &&
    Array.isArray((candidate as C).filterFunctionFactoryArgs) &&
    typeof (candidate as C).windowFunctionFactory === "string" &&
    Array.isArray((candidate as C).windowFunctionFactoryArgs) &&
    typeof (candidate as C).support === "number" &&
    typeof (candidate as C).scale === "number"
  );
}
